import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerStmtRezDetailService } from '../owner-stmt-rez-detail.service';
import { OwnerStmtRezDetail } from '../owner-stmt-rez-detail';
import { OwnerStmtRezDetailComponent } from '../owner-stmt-rez-detail/owner-stmt-rez-detail.component';

@Component({
    selector: 'app-owner-stmt-rez-detail-list',
    templateUrl: './owner-stmt-rez-detail-list.component.html',
    styleUrls: ['./owner-stmt-rez-detail-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OwnerStmtRezDetailListComponent implements OnInit {
	//ownerStmtRezId: any;

	constructor(
		private ownerStmtRezDetailService: OwnerStmtRezDetailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = ownerStmtRezDetailService.statuses
	}

	// data
	@Input() ownerStmtRezId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	ownerStmtRezDetails: any;
	ownerStmtRezDetail: OwnerStmtRezDetail;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'ownerStmtRezDetailId', header: 'Rez Detail Id', width: 'auto' },
		{ field: 'title', header: 'Title', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		// { field: 'status', header: 'Status', width: 'auto' },
		{ field: 'quantity ', header: 'Quantity', width: 'auto' },
		{ field: 'amount', header: 'Amount', width: 'auto' },
		{ field: 'taxAmount', header: 'Tax Amount', width: 'auto' },
		{ field: 'taxPct', header: 'Tax Pct', width: 'auto' },

	];

	ngOnInit(): void {
	console.log('ownerStmtRezId : ' + this.ownerStmtRezId);
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.	ownerStmtRezDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-owner-stmt-rez-detail-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.ownerStmtRezId)
			{
				// show only guestRefunds that are assigned to this guestRefundId
				let ownerStmtRezIdFilter = { 'ownerStmtRezId': { 'value': this.ownerStmtRezId, 'matchMode': 'in' } };
				Object.assign(event.filters, ownerStmtRezIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerStmtRezDetailService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerStmtRezDetails = res.data.ownerStmtRezDetails;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerStmtRezDetails = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ownerStmtRezDetail: OwnerStmtRezDetail) {
		try {
			this.formLoading = true;
			this.ownerStmtRezDetailService.update(ownerStmtRezDetail)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ownerStmtRezDetails.map((ownerStmtRezDetail, i) => {
							if (ownerStmtRezDetail.ownerStmtRezDetailId === res.data.ownerStmtRezDetail.ownerStmtRezDetailId) {
								this.ownerStmtRezDetails[i] = res.data.ownerStmtRezDetail;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ownerStmtRezDetail: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ownerStmtRezDetail));

			this.formLoading = true;
			this.ownerStmtRezDetailService.delete(ownerStmtRezDetail.ownerStmtRezDetailId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ownerStmtRezDetails.splice(this.ownerStmtRezDetails.indexOf(ownerStmtRezDetail), 1);
						this.recordTotal = this.ownerStmtRezDetails.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OwnerStmtRezDetail' + ownerStmtRezDetail.ownerStmtRezDetailId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OwnerStmtRezDetail' + ownerStmtRezDetail.ownerStmtRezDetailId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OwnerStmtRezDetail',
			ownerStmtRezId: this.ownerStmtRezId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtRezDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOwnerStmtRezDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ownerStmtRezDetail: OwnerStmtRezDetail) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerStmtRezDetail: ownerStmtRezDetail,
			title: 'Edit OwnerStmtRezDetail'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtRezDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOwnerStmtRezDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOwnerStmtRezDetailCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOwnerStmtRezDetailCB(ownerStmtRezDetail: OwnerStmtRezDetail) {
		console.log('Adding ownerStmtRezDetail: ' + JSON.stringify(ownerStmtRezDetail));
		// if we don't have a tests array yet...
		if (!this.ownerStmtRezDetails) {
			this.ownerStmtRezDetails = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ownerStmtRezDetails.unshift(ownerStmtRezDetail);

		// no idea what this is but it is required to update the array
		this.ownerStmtRezDetails = [...this.ownerStmtRezDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ownerStmtRezDetail ' + ownerStmtRezDetail.ownerStmtRezDetailId + ' Added', life: 3000 });
	}

	updateOwnerStmtRezDetailCB(ownerStmtRezDetail: OwnerStmtRezDetail) {
		console.log('Updating ownerStmtRezDetail: ' + JSON.stringify(ownerStmtRezDetail));
		let itemIndex = this.ownerStmtRezDetails.findIndex((item: any) => item.testId === ownerStmtRezDetail.ownerStmtRezDetailId);
		this.ownerStmtRezDetails[itemIndex] = ownerStmtRezDetail;

		// no idea what this is but it is required to update the array
		this.ownerStmtRezDetails = [...this.ownerStmtRezDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ownerStmtRezDetail ' + ownerStmtRezDetail.ownerStmtRezDetailId + ' Updated', life: 3000 });
	}

	deleteOwnerStmtRezDetailCB(ownerStmtRezDetail: OwnerStmtRezDetail) {
		console.log('Removing ownerStmtRezDetail: ' + ownerStmtRezDetail);
		this.ownerStmtRezDetails.splice(this.ownerStmtRezDetails.indexOf(ownerStmtRezDetail), 1);
		this.recordTotal = this.ownerStmtRezDetails.length;

		// no idea what this is but it is required to update the array
		this.ownerStmtRezDetails = [...this.ownerStmtRezDetails];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ownerStmtRezDetail' + ownerStmtRezDetail.ownerStmtRezDetailId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ownerStmtRezDetails ? this.first === (this.ownerStmtRezDetails.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ownerStmtRezDetails ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ownerStmtRezDetail: any) {
		if (ownerStmtRezDetail?.status) {
			const status = this.statuses.find((e: any) => e.value == ownerStmtRezDetail.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
